import axios from 'axios'


let request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 10000
})

// 请求拦截
request.interceptors.request.use(config => {
    console.log(config)
    return config
}, err => {
    console.log('errinfo:'+err)
})


// 响应拦截
request.interceptors.response.use(res => {
    return res
}, err => {
    console.log('errinfo:'+err)
})

export default request
